import React, { useState, useMemo, useEffect } from "react";
import {
    Button,
    Dialog,
    Stack,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
    Select, FormControl,
    Typography,
    MenuItem,
    useTheme,
} from "@mui/material";
import _ from "lodash";

const SettingsModel = ({ open, onClose, onSetAPIKey, apiKey }) => {
    const theme = useTheme();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Config</DialogTitle>
            <Divider />
            <DialogContent>

                <Stack direction='row' spacing={1} alignItems={'center'}>
                    <Typography>ApiKey:</Typography>
                    <FormControl
                        size="small"
                        sx={{ cursor: "pointer", minWidth: "200px", pr: 2 }}
                        fullWidth
                    >
                        <Select
                            sx={{ backgroundColor: theme.palette.background.paper }}
                            value={apiKey}
                            onChange={(e) => onSetAPIKey(e.target.value)}
                            fullWidth
                        >
                            <MenuItem key={'IR'} value={'IR'}>
                                {'Insight Results'}
                            </MenuItem>
                            <MenuItem key={'RR'} value={'RR'}>
                                {'Right Response'}
                            </MenuItem>

                        </Select>
                    </FormControl>
                </Stack>

            </DialogContent>
            <Divider />
            <DialogActions
                sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
            >
                <Button
                    onClick={onClose}
                    size="small"
                    variant="outlined"
                    // color="error"
                // sx={{ ml: 2 }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SettingsModel;
